module.exports = __webpack_public_path__ + "static/media/gilbert-face.68d28582.jpg";